import React from 'react';
import { EnhancedFeedPage } from './EnhancedFeedPage';

export const FeedPage = () => {
  return <EnhancedFeedPage />;
};